import * as React from 'react';
import useOnlineMap from './hooks/useOnlineMap';

interface ILogicProps {
  googleMap: google.maps.Map | undefined;
}

export default function Logic(props: ILogicProps): null {
  useOnlineMap(props.googleMap);

  return null;
}
